import {api} from "../../services";
import Swal from "sweetalert2";

const channels = {
  state: {
    pagination: [],
    data: [],
    channel: {},
    edit: {
      department_id: null,
      funnel: {
        name: ""
      },
    },
    flow_new_channel: {
      company: {
        name: null,
        address: {
          zip_code: null,
          country: null,
          district: null,
          city: null,
          state: null,
          number: null,
          street: null,
        },
      },
      type_key: null,
      integration_key: null,
      departments:[],
      users: [],
    },
    search_channel: {
      name: null,
      phone: null
    },
    integration: {
      data: {}
    },
    plan: {},
    plan_edit: {
      status: 1,
      email: null,
      code: null,
      type: null
    },
    plan_edit_code: null,
    api_hooks: {
      hook_receiver: null,
      hook_status: null,
    },
    channel_telegram_groups: [],
    qrcode_url: null,
    socket_baileys: null,
    onlyCountries:['AD', 'AO', 'AR', 'AU', 'BR', 'BE', 'BO', 'CM', 'CA', 'CL', 'CN', 'CO', 'CR', 'CU', 'DK', 'EC', 'FR', 'DE', 'GR', 'IN', 'IT', 'LU', 'MX', 'MA', 'NL', 'NO', 'PA', 'PY', 'PE', 'PH', 'PL', 'PT', 'PR', 'RO', 'RU', 'BL', 'SG', 'ZA', 'ES', 'SE', 'CH', 'TR', 'UG', 'US', 'GB', 'UY', 'VE']
  },
  getters: {
    getChannelObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getChannelsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getWalletChannelsBoolean: (state) => () => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item.parameter && item.parameter.modules && item.parameter.modules.wallet === 1;
        }).length > 0;
      }
      return false;
    },
    getGalerryChannelsAvailableArray: (state) => () => {
      // Lista canais que:
      // 1) Não possuem API Oficial
      // 2) Não estão bloqueados
      // 3) Estão com o módulo Marketing Habilitado
      if (state.data !== undefined) {
        return state.data.filter(channel => {
          // return channel.integrations[9].status_key === false && channel.status_key > 0 && channel.parameter.modules.campaign === 1;
          return channel.status_key > 0
            && channel.parameter
            && channel.parameter.modules
            && channel.parameter.modules
            && channel.parameter.modules.gallery === 1;
        });
      }
      return [];
    },
    getCampaignsChannelsAvailableArray: (state) => () => {
      // Lista canais que:
      // 1) Não possuem API Oficial
      // 2) Não estão bloqueados
      // 3) Estão com o módulo Marketing Habilitado
      if (state.data !== undefined) {
        return state.data.filter(channel => {
          // return channel.integrations[9].status_key === false && channel.status_key > 0 && channel.parameter.modules.campaign === 1;
          return channel.status_key > 0
            && channel.parameter
            && channel.parameter.modules
            && channel.parameter.modules.campaign === 1;
        });
      }
      return [];
    },
    getCampaignsFilterOfficialChannelArray: (state) => () => {
      // Lista canais que tem API oficial ativa:
      if (state.data !== undefined) {
        let channels = state.data.filter(channel => {
          return channel.integrations
            && (
              channel.integrations[12] && channel.integrations[12].status_key
              || channel.integrations[13] && channel.integrations[13].status_key
              )
            && channel.status_key > 0
            && channel.parameter && channel.parameter.modules && channel.parameter.modules.campaign === 1
        });
        return channels
      }
      return [];
    },
    getChannelsFilterNoOfficialAndAvailableArray: (state) => () => {
      if (state.data !== undefined) {
        let channels = state.data.filter(item => {
          return item.status_key > 0
            && item.parameter
            && item.parameter.modules.campaign === 1
            && !item.integrations
            && !item.integrations[9].status_key
            && !item.integrations[9].data.token
            && !item.integrations[9].data.token !== '';
        });
        return channels;
      }
      return [];
    },
    getLeadsChannelsBoolean: (state) => () => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item.parameter && item.parameter.modules.active === 1;
        }).length > 0;
      }
      return false;
    },
    getChannelTelegramObject: (state) => (key, value) => {
      const object = state.channel_telegram_groups.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
  },
  mutations: {
    SET_CHANNELS(state, payload) {
      state.pagination = payload
      this.commit("SET_CHANNELS_DATA", payload.data);
    },
    SET_CHANNELS_DATA(state, payload) {
      payload.forEach(p => {
        const exist = state.data.find(e => {
          return e.id === p.id;
        });
        if (!exist) {
          state.data.push(p);
        }
      });
    },
    SET_CHANNEL(state, payload) {
      if (Array.isArray(payload.parameter.messages.default)) payload.parameter.messages.default = {}
      if (Array.isArray(payload.parameter.messages.idle)) payload.parameter.messages.idle = {}
      if (Array.isArray(payload.parameter.messages.survey)) payload.parameter.messages.survey = {}
      if (Array.isArray(payload.parameter.times.idle)) payload.parameter.times.idle = {}
      if (Array.isArray(payload.parameter.times.default)) payload.parameter.times.default = {}
      if (Array.isArray(payload.parameter.bot)) payload.parameter.bot = {}
      if (Array.isArray(payload.company.address)) payload.company.address = {}
      // Ajutado payload com novas opções de webhook
      if (!payload.infos.webhook.campaign) {
        payload.infos.webhook.campaign = {
          broadcast: null,
          status: null
        }
      }
      // Ajutado payload com nova opção de módulo - Notificação
      if (!payload.parameter && payload.parameter.modules && payload.parameter.modules.notification) {
        payload.parameter.modules.notification = 0
      }
      state.channel = payload
    },
    SET_CHANNEL_TELEGRAM_GROUPS(state, payload) {
      state.channel_telegram_groups = payload
    },
  },
  actions: {
    getChannels(context, payload) {
      api.get('/channels', {
        params: payload
      }).then(response => {
        context.commit("SET_CHANNELS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getChannel(context, payload) {
      api.get(`/channels/${payload.id}`).then(response => {
        context.rootState.baileys_integration.channel_id = response.data.id
        this.dispatch('verifyWhatIsTheUrlBaileys');

        context.commit("SET_CHANNEL", response.data);
        /*const channel = response.data;
        const is_dialog_active = channel.integrations[9].status_key;
        const is_cloudapi_active = channel.integrations[12] && channel.integrations[12].status_key;

        if (is_dialog_active || is_cloudapi_active) {
          this.dispatch('getTemplates', channel)
        }*/

       if(context.state.channel.parameter.modules.identify_agent == undefined) {
        context.state.channel.parameter.modules.identify_agent = 0;
       }

       if(context.state.channel.parameter.modules.gallery == undefined) {
        context.state.channel.parameter.modules.gallery = 0;
       }

        if(context.state.channel.integrations.length === 11) {
          context.state.channel.integrations.push(
            {
              "name": "whatsappwebqrcode",
              "status_key": false,
              "type_key": 1,
              "data": {
                "session": false
              }
            }
          )
        }

        if(context.state.channel.integrations.length === 12) {
          context.state.channel.integrations.push(
            {
              "name": "whatsappbussinessapiofficial",
              "status_key": false,
              "type_key": 1,
              "data": {
                "token" :  null,
                "number" :  null,
                "waba_id" :  null,
                "app_id" :  null
              }
            }
          )
          context.state.channel.integrations.push(
            {
              "name": "instagramapiofficial",
              "status_key": false,
              "type_key": 1,
              "data": {
                "token": false
              }
            }
          )
          context.state.channel.integrations.push(
            {
              "name": "messengerapiofficial",
              "status_key": false,
              "type_key": 1,
              "data": {
                "token": false
              }
            }
          )
        }
        if(context.state.channel.integrations[15] === undefined) {
          context.state.channel.integrations.push(
            {
              "name": "whatsappwebqrcode_2.0",
              "status_key": false,
              "type_key": 1,
              "data": {
                "session": false
              }
            }
          )
        } else {
          context.state.channel.integrations[15].name = 'whatsappwebqrcode_2.0';
        }

        if (context.state.channel.integrations[9].name == '360dialog') {
          context.state.channel.integrations[9].name = 'whatsappbussinessapi';
        }

        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getChannelsData(context, payload) {
      let ids = [];
      payload.forEach(p => {
        const item = context.state.data.find(i => {
          return p === i.id
        });
        if (item === undefined) {
          ids.push(p);
        }
      });
      if (ids.length > 0) {
        api.post(`/channels`, {ids}).then(response => {
          context.commit("SET_CHANNELS_DATA", response.data);
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      }
    },
    getChannelsAll(context) {
      api.get(`/channels/all`).then(response => {
        context.commit("SET_CHANNELS_DATA", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    silentUpdateChannel(context, payload){
      api.put(`/channels/${payload.id}`, payload).then(response => {
        this.state.channels.channel = response.data
        this.state.channels.channel.parameter = response.data.parameter
        this.state.channels.channel.bot_url_file = response.data.bot_url_file
        this.state.channels.channel.bot_mime_type_file = response.data.bot_mime_type_file
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } 
      });
    },



     








    updateChannel(context, payload) {
      api.put(`/channels/${payload.id}`, payload).then(response => {
        this.state.channels.channel = response.data
        this.state.channels.channel.parameter = response.data.parameter
        this.state.channels.channel.bot_url_file = response.data.bot_url_file
        this.state.channels.channel.bot_mime_type_file = response.data.bot_mime_type_file
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: `${context.rootGetters.getTranslations('expression_911')}`,
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
   







    addChannel(context, payload) {
      api.post(`/channels`, payload).then((response) => {
        this.dispatch('getChannels', payload)
        window.localStorage.setItem("channel_id", response.data.id)
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_912'),
          showConfirmButton: false,
          timer: 1500
        })
        window.router.push({name: 'Channel'})
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },







    getChannelTelegram(context, payload) {
      api.get(`/channels/telegram/${payload}`).then(response => {
        context.commit("SET_CHANNEL_TELEGRAM_GROUPS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    syncWebhookChannel() {
      api.post(`/channels/sync-webhook`).then(() => {
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    syncHsmChannel(context) {
      const channel = context.rootState.channels.channel;
      let endpoint = null;
      const is_dialog_active = channel.integrations[9].status_key;
      const is_cloudapi_active = channel.integrations[12] && channel.integrations[12].status_key;


      if (is_dialog_active) {
        endpoint = `/channels/sync-hsm`;
      } else if (is_cloudapi_active) {
        endpoint = `/channels/integrations/12/actions/update_templates`;
      }

      api.post(`${endpoint}`, {channel_id: channel.id}).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: `${context.rootGetters.getTranslations('expression_1198')}`,
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          setTimeout(() => {
            this.dispatch('getTemplates', channel)
          }, 1000)
        })

      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getToken360DialogChannel(context, payload) {
      let channelsOfficial = window.localStorage.getItem(`channel_activation_official_channels_${payload.channel_id}`);
      channelsOfficial = channelsOfficial.replaceAll('[', '').replaceAll(']', '').split(',');
      const channelOfficial = Array.from(channelsOfficial)[0];
      api.post(`/channels/get-token-channel-official`, {channelOfficial, channel_id: payload.channel_id}).then(() => {
        window.localStorage.removeItem(`channel_activation_official_channels_${payload.channel_id}`);
        window.localStorage.removeItem(`channel_activation_official_client_${payload.channel_id}`);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default channels;











